import { Component } from '@angular/core';

@Component({
  selector: 'app-govconavbar',
  standalone: true,
  imports: [],
  templateUrl:
    './../../../../Presentation/components/govconavbar/govconavbar.component.html',
  styleUrl:
    './../../../../Presentation/components/govconavbar/govconavbar.component.scss',
})
export class GovconavbarComponent {}
